import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

import { PayoffPostDisbursementChangeModel } from "@/models/loans";
import { TableHeader } from "@/models/table";


export default /*@__PURE__*/_defineComponent({
  __name: 'PostDisbursementChangeRow',
  props: {
    postDisbursementChange: {},
    headers: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tr", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.headers, (header) => {
      return (_openBlock(), _createElementBlock("td", {
        key: header[`${header.key}`]
      }, _toDisplayString(__props.postDisbursementChange[`${header.key}`]), 1))
    }), 128))
  ]))
}
}

})